import { Link } from '@amzn/awsui-components-core';
import React, { useContext } from 'react';
import constants from '../../../../../common/constants';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { InputFormField } from './InputFormField';
import {
  appsecTicketAllowedPathValidation,
  inputLengthValidation,
  requiredFieldValidation,
  validUrlValidation,
} from './Validations';

export const SecurityReviewUrlFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);
  const validations = [
    requiredFieldValidation,
    validUrlValidation,
    inputLengthValidation,
    appsecTicketAllowedPathValidation,
  ];
  const description = (
    <>
      <Link
        href="https://sim.amazon.com/issues/create?template=c806913f-810b-4e85-a84e-437a6243cfd4"
        external
        variant="info"
      >
        {constants.CODE_REPO_SECURITY_REVIEW_INFO_LINK_1}
      </Link>{' '}
      {constants.CODE_REPO_SECURITY_REVIEW_INFO_TEXT_1}{' '}
      <Link
        href="https://talos.security.aws.a2z.com/#/talos/guardian-finder"
        external
        variant="info"
      >
        {constants.CODE_REPO_SECURITY_REVIEW_INFO_LINK_2}
      </Link>{' '}
      {constants.CODE_REPO_SECURITY_REVIEW_INFO_TEXT_2}
    </>
  );
  const updateSecurityReviewUrl = (newValue: string) => ({ securityReviewUrl: newValue });
  return (
    <InputFormField
      fieldId="security_review_url"
      label="Security review URL*"
      description={description}
      validations={validations}
      value={repoData.securityReviewUrl}
      setValue={updateSecurityReviewUrl}
    />
  );
};
